import Default from './default';

import VideoSlider from '../components/video-slider';

class Home extends Default {
	namespace = 'home';

	beforeEnter = data => {
		super.beforeEnter(data);
		const scope = data.next.container;
		this.initVideoSlider(scope);
	};

	afterLeave = data => {
		super.afterLeave(data);
	};

	afterEnter = data => {
		super.afterEnter(data);
	};

	initVideoSlider = scope => {
		const $videoSlider = $('[data-video-slider="el"]');
		if ($videoSlider) {
			new VideoSlider($videoSlider);
		}
	};
}

export default new Home();
